
export const common = {
  // Header
  "site_title": "Invitation Registration System",
  "site_subtitle": "rsvp.ion.global",
  
  // Form
  "event_registration_form": "Event Registration Form",
  "form_description": "Please enter your name and participation status.",
  "full_name": "Full Name",
  "full_name_placeholder": "Enter your first and last name",
  "participation_question": "Will you attend the event?",
  "yes_participate": "Yes, I will attend",
  "no_participate": "No, I won't attend",
  
  // Buttons
  "confirm_rsvp": "Confirm My RSVP",
  "submitting": "Submitting...",
  
  // Messages
  "registration_success": "Registration Successful!",
  "registration_success_message": "Your participation has been successfully registered. Thank you!",
  "registration_error": "Registration Error",
  "registration_error_message": "An error occurred. Please try again.",
  
  // Validation
  "name_required": "Please enter your first and last name.",
  "participation_required": "Please select your participation status.",
  
  // Footer
  "copyright": "© 2025 rsvp.ion.global - All rights reserved.",
  "powered_by": "Powered by ion.global"
};

export default common;
